module.exports = __webpack_public_path__ + "static/media/prof3.91a2f530.png";